<div class="intl-phone" [class.is-disabled]="isDisabled">
  <button
    class="country-selector"
    type="button"
    [disabled]="isDisabled"
    (click)="toggleDropdown()"
    (blur)="markAsTouched()"
    [attr.aria-expanded]="isOpen"
  >
    <span [class]="flagClass"></span>
    <span class="dial-code">+{{ selectedCountry?.dialCode }}</span>
    <i class="bi bi-chevron-down"></i>
  </button>

  <input
    class="phone-number"
    [id]="inputId"
    type="tel"
    [disabled]="isDisabled"
    [value]="nationalNumber"
    [placeholder]="placeholder"
    (input)="onPhoneInput($any($event.target).value)"
    (blur)="markAsTouched()"
  />

  <div class="country-dropdown" *ngIf="isOpen">
    <input
      class="country-search"
      type="text"
      [(ngModel)]="searchText"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="filterCountries()"
      placeholder="Buscar país o código"
    />

    <button
      class="country-option"
      type="button"
      *ngFor="let country of filteredCountries"
      (click)="selectCountry(country)"
    >
      <span class="fi fi-{{ country.iso2.toLowerCase() }}"></span>
      <span class="country-name">{{ country.name }}</span>
      <span class="country-code">+{{ country.dialCode }}</span>
    </button>
  </div>
</div>
